/* global document, window, localStorage, CustomEvent */

( function () {
	const WL_KEY = 'icfWishlistIds';

	const onReady = ( fn ) => {
		if ( document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	};

	/* ── Quantity ± buttons (works on PDP, cart, anywhere) ───────── */
	const initQtyControls = () => {
		document.addEventListener( 'click', ( e ) => {
			const decBtn = e.target.closest( '[data-qty-decrement]' );
			const incBtn = e.target.closest( '[data-qty-increment]' );
			if ( ! decBtn && ! incBtn ) return;

			const wrap = ( decBtn || incBtn ).closest( '[data-qty-control]' );
			if ( ! wrap ) return;

			const input = wrap.querySelector( 'input.qty' );
			if ( ! input ) return;

			const step = parseFloat( input.getAttribute( 'step' ) ) || 1;
			const min = input.hasAttribute( 'min' ) ? parseFloat( input.getAttribute( 'min' ) ) : 1;
			const maxAttr = input.getAttribute( 'max' );
			const max = maxAttr ? parseFloat( maxAttr ) : null;
			const current = parseFloat( input.value ) || 0;
			let next = decBtn ? current - step : current + step;

			if ( next < min ) next = min;
			if ( max !== null && next > max ) next = max;

			input.value = next;
			input.dispatchEvent( new CustomEvent( 'change', { bubbles: true } ) );
		} );
	};

	/* ── Gallery: thumbnail swap + variation image sync ──────────── */
	const initGallery = () => {
		const main = document.querySelector( '[data-gallery-main]' );
		if ( ! main ) return;

		const mainImg = main.querySelector( 'img' );
		if ( ! mainImg ) return;

		const thumbs = Array.from(
			document.querySelectorAll( '[data-gallery-thumb]' )
		);

		// Featured image, remembered so we can restore it when a variation
		// selection is cleared/reset.
		const defaultSrc = mainImg.getAttribute( 'src' ) || '';
		const defaultSrcset = mainImg.getAttribute( 'srcset' ) || '';

		// Match an image's object-fit to its orientation (portrait → contain,
		// landscape/square → cover), mirroring product-image.blade.php.
		const applyFit = ( fit ) => {
			if ( ! fit ) return;
			mainImg.classList.toggle( 'object-fit-contain', fit === 'contain' );
			mainImg.classList.toggle( 'object-fit-cover', fit !== 'contain' );
		};

		const setMainImage = ( src, srcset, fit ) => {
			if ( ! src ) return;
			if ( mainImg.dataset.src ) mainImg.dataset.src = src;
			mainImg.src = src;
			mainImg.srcset = srcset || '';
			if ( mainImg.dataset.srcset !== undefined ) {
				mainImg.dataset.srcset = srcset || '';
			}
			applyFit( fit );
		};

		const activateThumb = ( thumb ) => {
			thumbs.forEach( ( t ) => t.classList.remove( 'is-active' ) );
			if ( thumb ) thumb.classList.add( 'is-active' );
		};

		const thumbByImgId = ( id ) =>
			thumbs.find(
				( t ) => String( t.getAttribute( 'data-img-id' ) ) === String( id )
			);

		// Thumbnail click → preview that image.
		thumbs.forEach( ( thumb ) => {
			thumb.addEventListener( 'click', () => {
				const fullSrc = thumb.getAttribute( 'data-img-full' );
				if ( ! fullSrc ) return;
				activateThumb( thumb );
				setMainImage(
					fullSrc,
					thumb.getAttribute( 'data-img-srcset' ) || '',
					thumb.getAttribute( 'data-img-fit' )
				);
			} );
		} );

		// Variation selected → swap the main image to the variation's image and
		// highlight its thumbnail. WooCommerce fires `found_variation` on the
		// variations form once a full variation resolves. The gallery lives
		// OUTSIDE that form, and WC's own image swap targets
		// `.woocommerce-product-gallery` (which this theme replaces) — so
		// without this listener the main image never updates on variation change.
		if ( window.jQuery ) {
			const $ = window.jQuery;

			$( document ).on(
				'found_variation',
				'form.variations_form',
				( e, variation ) => {
					if ( ! variation || ! variation.image || ! variation.image.src ) {
						return;
					}
					const match = variation.image_id
						? thumbByImgId( variation.image_id )
						: null;
					setMainImage(
						variation.image.src,
						variation.image.srcset || '',
						match ? match.getAttribute( 'data-img-fit' ) : null
					);
					if ( match ) activateThumb( match );
				}
			);

			// Selection cleared / reset → restore the featured image.
			$( document ).on( 'reset_image', 'form.variations_form', () => {
				setMainImage(
					defaultSrc,
					defaultSrcset,
					thumbs[ 0 ] ? thumbs[ 0 ].getAttribute( 'data-img-fit' ) : null
				);
				activateThumb( thumbs[ 0 ] || null );
			} );
		}
	};

	/* ── Buy Now → submit form to checkout URL ───────────────────── */
	const initBuyNow = () => {
		document.addEventListener( 'click', ( e ) => {
			const btn = e.target.closest( '[data-buy-now]' );
			if ( ! btn ) return;

			const form = btn.closest( 'form.product-actions-form' );
			if ( ! form ) return;

			const checkoutUrl = form.getAttribute( 'data-checkout-url' );
			if ( checkoutUrl ) {
				form.setAttribute( 'action', checkoutUrl );
			}
		} );
	};

	/* ── Wishlist (visual-only, localStorage-backed) ─────────────── */
	const loadWishlist = () => {
		try {
			const raw = localStorage.getItem( WL_KEY );
			const arr = raw ? JSON.parse( raw ) : [];
			return Array.isArray( arr ) ? arr : [];
		} catch ( err ) {
			return [];
		}
	};

	const saveWishlist = ( ids ) => {
		try {
			localStorage.setItem( WL_KEY, JSON.stringify( ids ) );
		} catch ( err ) {
			// Storage unavailable; fail silently.
		}
	};

	const syncWishlistButton = ( btn, ids ) => {
		const id = btn.getAttribute( 'data-product-id' );
		const on = ids.indexOf( id ) > -1;
		btn.classList.toggle( 'is-active', on );
		btn.setAttribute( 'aria-pressed', on ? 'true' : 'false' );
		btn.setAttribute(
			'aria-label',
			on ? 'Remove from wishlist' : 'Add to wishlist'
		);
	};

	const initWishlist = () => {
		const buttons = document.querySelectorAll( '[data-wishlist]' );
		if ( ! buttons.length ) return;

		const ids = loadWishlist();
		buttons.forEach( ( btn ) => syncWishlistButton( btn, ids ) );

		document.addEventListener( 'click', ( e ) => {
			const btn = e.target.closest( '[data-wishlist]' );
			if ( ! btn ) return;

			const id = btn.getAttribute( 'data-product-id' );
			if ( ! id ) return;

			const list = loadWishlist();
			const i = list.indexOf( id );
			if ( i > -1 ) {
				list.splice( i, 1 );
			} else {
				list.push( id );
			}
			saveWishlist( list );

			document
				.querySelectorAll( '[data-wishlist]' )
				.forEach( ( b ) => syncWishlistButton( b, list ) );

			document.dispatchEvent(
				new CustomEvent( 'icf:wishlist-changed', { detail: { ids: list } } )
			);
		} );
	};

	/* ── Variation chip groups (variable products) ───────────────── */
	const parseVariations = ( form ) => {
		const raw = form.getAttribute( 'data-product_variations' );
		if ( ! raw ) return [];
		try {
			const data = JSON.parse( raw );
			return Array.isArray( data ) ? data : [];
		} catch ( err ) {
			return [];
		}
	};

	const collectSelection = ( form ) => {
		const selection = {};
		form.querySelectorAll( '.variations select[name^="attribute_"]' ).forEach(
			( select ) => {
				selection[ select.name ] = select.value;
			}
		);
		return selection;
	};

	const findVariationSelect = ( form, name ) =>
		form.querySelector( `.variations select[name="${ name }"]` );

	const variationMatches = ( variation, selection, ignoreKey = null ) => {
		return Object.keys( selection ).every( ( key ) => {
			if ( key === ignoreKey ) return true;
			const sel = selection[ key ];
			if ( ! sel ) return true;
			const variationVal = variation.attributes && variation.attributes[ key ];
			// Empty variation attr = "any" (matches anything).
			if ( ! variationVal ) return true;
			return variationVal === sel;
		} );
	};

	const refreshChipStates = ( form ) => {
		const variations = parseVariations( form );
		if ( ! variations.length ) return;

		const selection = collectSelection( form );

		form.querySelectorAll( '[data-chip-group]' ).forEach( ( group ) => {
			const groupKey = group.getAttribute( 'data-chip-group' );
			let availableInGroup = 0;

			group.querySelectorAll( '[data-chip-value]' ).forEach( ( chip ) => {
				const chipValue = chip.getAttribute( 'data-chip-value' );
				const trial = { ...selection, [ groupKey ]: chipValue };

				const hasMatch = variations.some( ( v ) => {
					// An option only counts as available when a matching
					// variation is both purchasable AND in stock — so
					// out-of-stock / unavailable options are hidden outright
					// (see `.option-chip.is-disabled` in SCSS) rather than shown
					// as dead greyed-out chips.
					if ( v.is_purchasable === false ) return false;
					if ( v.is_in_stock === false ) return false;
					return variationMatches( v, trial );
				} );

				chip.classList.toggle( 'is-disabled', ! hasMatch );
				if ( hasMatch ) availableInGroup += 1;
			} );

			// If every option in this attribute is unavailable (e.g. all
			// variations out of stock), hide the whole group so its label isn't
			// left stranded above an empty row.
			const wrapper = group.closest( '.option-group' );
			if ( wrapper ) {
				wrapper.classList.toggle( 'is-empty', availableInGroup === 0 );
			}
		} );
	};

	const setChipActive = ( group, chip ) => {
		group.querySelectorAll( '[data-chip-value]' ).forEach( ( c ) => {
			const on = c === chip;
			c.classList.toggle( 'is-active', on );
			c.setAttribute( 'aria-checked', on ? 'true' : 'false' );
		} );
	};

	const initVariationChips = () => {
		const forms = document.querySelectorAll( 'form.variations_form' );
		if ( ! forms.length ) return;

		forms.forEach( ( form ) => {
			refreshChipStates( form );
		} );

		document.addEventListener( 'click', ( e ) => {
			const chip = e.target.closest( '[data-chip-value]' );
			if ( chip ) {
				if ( chip.classList.contains( 'is-disabled' ) ) {
					e.preventDefault();
					return;
				}

				const group = chip.closest( '[data-chip-group]' );
				const form = chip.closest( 'form.variations_form' );
				if ( ! group || ! form ) return;

				const groupKey = group.getAttribute( 'data-chip-group' );
				const wasActive = chip.classList.contains( 'is-active' );
				const newValue = wasActive ? '' : chip.getAttribute( 'data-chip-value' );

				if ( wasActive ) {
					chip.classList.remove( 'is-active' );
					chip.setAttribute( 'aria-checked', 'false' );
				} else {
					setChipActive( group, chip );
				}

				const select = findVariationSelect( form, groupKey );
				if ( select ) {
					select.value = newValue;
					if ( window.jQuery ) {
						// Use jQuery so WC's `$form.on('change', ...)` handler fires.
						window.jQuery( select ).trigger( 'change' );
					} else {
						select.dispatchEvent( new Event( 'change', { bubbles: true } ) );
					}
				}

				refreshChipStates( form );
				return;
			}

			const reset = e.target.closest( '.reset_variations' );
			if ( reset ) {
				const form = reset.closest( 'form.variations_form' );
				if ( ! form ) return;

				form.querySelectorAll( '[data-chip-value].is-active' ).forEach( ( c ) => {
					c.classList.remove( 'is-active' );
					c.setAttribute( 'aria-checked', 'false' );
				} );
				form.querySelectorAll(
					'.variations select[name^="attribute_"]'
				).forEach( ( select ) => {
					select.value = '';
				} );

				// WC's add-to-cart-variation.js handles the rest of the reset
				// (price wipe, button disable) via its own click handler.
				setTimeout( () => refreshChipStates( form ), 0 );
			}
		} );

		// WC fires this jQuery event after rebuilding which options are still
		// available given current selection. Re-sync chip disabled states.
		if ( window.jQuery ) {
			window.jQuery( document ).on(
				'woocommerce_update_variation_values reset_data found_variation',
				'form.variations_form',
				( e ) => {
					refreshChipStates( e.currentTarget );
				}
			);
		}
	};

	onReady( () => {
		initQtyControls();
		initGallery();
		initBuyNow();
		initWishlist();
		initVariationChips();
	} );
} )();
